import {
  DeleteOutlined,
  FullscreenOutlined,
  LoadingOutlined,
  PlusOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Collapse,
  Divider,
  Flex,
  Popconfirm,
  Result,
  Spin,
} from "antd";
import Meta from "antd/es/card/Meta";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../api";
import { RootState, useAppSelector } from "../../../store";
import { AppState } from "../../../store/appSlice";
import { AuthState } from "../../../store/authSlice";

const AdminUsers = () => {
  const auth = useSelector<RootState, AuthState>((state) => state.auth);
  const { field_Language, lang } = useAppSelector(
    (data: { app: AppState }) => data.app
  );
  const { t } = useTranslation();
  const navigate = useNavigate();

  // authorized company users list
  const {
    data: authorizedCompanies,
    isLoading: isAuthorizedUsersLoading,
    refetch: refetchAuthorizedCompanies,
  } = api.useGetAdminAuthorizedCompaniesQuery(undefined);

  const { data: countries, isLoading: isCountriesLoading } =
    api.useGetCountriesQuery(undefined);

  // remove company
  const [removeCompany, { isLoading: isRemoveCompanyLoading }] =
    api.useRemoveCompanyMutation();

  // remove user in admin functon
  const removeCompanyFun = async (companyId: number) => {
    if (companyId) {
      try {
        await removeCompany(companyId).unwrap();
        // refetch authorized users
        refetchAuthorizedCompanies();
        //
        toast.success(`${t("company")} ${t("deletedSuccessfully")}`);
        //
      } catch (error) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0];
          const errorMessage = firstError.message;
          toast.error(errorMessage);
        } else {
          toast.error(`${t("errorOccurred")}`);
        }
      }
    }
  };

  // main loading
  const MainLoading =
    isAuthorizedUsersLoading || isRemoveCompanyLoading || isCountriesLoading;

  const refetchCompanies = useCallback(() => {
    refetchAuthorizedCompanies();
  }, [refetchAuthorizedCompanies]);

  // refetch companies
  useEffect(() => {
    refetchCompanies();
    return () => {};
  }, [refetchCompanies]);

  const groupedByCountry = useMemo(() => {
    if (!countries?.length || !authorizedCompanies?.length) return [];

    return countries
      .map((country) => {
        const matchedCompanies = authorizedCompanies.filter(
          (company) => company.countryCode === country.isoCode
        );
        if (matchedCompanies.length === 0) return null;

        return {
          country: {
            isoCode: country.isoCode,
            image: country.iconUrl,
            name: country.translations?.[field_Language]?.name || country.name,
          },
          companies: matchedCompanies,
        };
      })
      .filter(Boolean);
  }, [countries, authorizedCompanies, field_Language]);

  console.log("groupedByCountry", groupedByCountry);

  return (
    <>
      {(auth?.user?.companyUsers[0]?.role || auth?.user?.userType) !==
      "Frani-Admin" ? (
        <Flex justify="center" align="center" style={{ height: "100%" }}>
          <Result
            title="თქვენ არ გაქვთ წვდომა მიმდინარე გვერდზე !!!"
            extra={
              <Button type="primary" size="large" onClick={() => navigate("/")}>
                {t("homePage")}
              </Button>
            }
          />
        </Flex>
      ) : (
        <>
          {MainLoading ? (
            <Flex justify="center" align="center" style={{ height: "100%" }}>
              <Spin indicator={<LoadingOutlined spin />} size="large" />
            </Flex>
          ) : (
            <>
              <Button
                size="large"
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate(`/company-detail/0`)}
              >
                {t("create")}
              </Button>

              {authorizedCompanies && (
                <>
                  <Divider />

                  <Collapse
                    accordion
                    size="large"
                    items={groupedByCountry.map((item, index) => ({
                      key: index,
                      label: (
                        <Flex justify="space-between">
                          <img
                            style={{
                              height: 25,
                              width: 25,
                              objectFit: "contain",
                            }}
                            src={item?.country.image}
                            alt="flag"
                          />
                          {item?.country?.name}
                        </Flex>
                      ),
                      children: (
                        <>
                          <Divider />

                          <Flex
                            wrap="wrap"
                            gap={15}
                            justify="space-around"
                            align="center"
                            style={{ marginTop: 20 }}
                          >
                            {item?.companies.map((company, companyIndex) => (
                              <Card
                                key={companyIndex}
                                style={{
                                  maxWidth: 350,
                                  width: "100%",
                                  height: "",
                                  cursor: "default",
                                }}
                                hoverable
                                cover={
                                  <img
                                    style={{
                                      paddingTop: 10,
                                      width: 150,
                                      height: 150,
                                      objectFit: "contain",
                                      marginInline: "auto",
                                    }}
                                    alt={`company-cover---${company?.cover}`}
                                    src={company?.cover}
                                  />
                                }
                                actions={[
                                  <Button
                                    // detail screen
                                    type="link"
                                    onClick={() =>
                                      navigate(`/company-detail/${company.id}`)
                                    }
                                    style={{
                                      display: "grid",
                                      placeItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <FullscreenOutlined
                                      style={{
                                        fontSize: 16,
                                        height: 16,
                                        width: 16,
                                      }}
                                    />
                                  </Button>,

                                  <Button
                                    // company users
                                    type="link"
                                    onClick={() =>
                                      navigate(
                                        `/authorized-company-users/${company.id}`
                                      )
                                    }
                                    style={{
                                      display: "grid",
                                      placeItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <UsergroupAddOutlined
                                      style={{
                                        fontSize: 16,
                                      }}
                                    />
                                  </Button>,

                                  <Popconfirm
                                    // delete company
                                    title={t("certainToDeleteIt")}
                                    onConfirm={() =>
                                      removeCompanyFun(company.id)
                                    }
                                    onCancel={() => {}}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="link"
                                      style={{
                                        display: "grid",
                                        placeItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <DeleteOutlined
                                        style={{
                                          fontSize: 16,
                                        }}
                                      />
                                    </Button>
                                  </Popconfirm>,
                                ]}
                              >
                                <Meta
                                  style={{ minHeight: 80 }}
                                  avatar={<Avatar src={company?.logo} />}
                                  title={company?.translations?.[lang]?.title}
                                  description={
                                    company?.translations?.[lang]?.excerpt
                                  }
                                />
                              </Card>
                            ))}
                          </Flex>
                        </>
                      ),
                    }))}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default AdminUsers;
